export const homeRoute = "/";
export const profileRoute = "/profile";
/** Campaign view (no :id – selected campaign comes from store/config) */
export const campaignRoute = "/campaign";
export const campaignOverviewRoute = "/campaign";
